import React from "react";
import { Icon } from "antd";
import NumberFormat from "../../../../NumberFormat";

/* update_campaign_budget — cambio de presupuesto (solo programáticas). */
export default function BudgetProposal({ payload, t }) {
  return (
    <div className="chatbot-proposal-body">
      <p className="chatbot-proposal-reason">{t("ChatbotProposalBudget")}</p>
      <div className="chatbot-proposal-change-row">
        <span>
          {payload.current_budget != null ? (
            <NumberFormat
              value={payload.current_budget}
              currency={payload.currency}
            />
          ) : ""}
        </span>
        <Icon type="arrow-right" />
        <span className="chatbot-proposal-new-value">
          {payload.new_budget != null ? (
            <NumberFormat
              value={payload.new_budget}
              currency={payload.currency}
            />
          ) : ""}
        </span>
      </div>
    </div>
  );
}
